import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n";
import { services } from "../data/services";
import { Seo } from "../components/site/Seo";
import { MaskLine, FadeUp } from "../components/site/Reveal";
import { CTA } from "../components/site/CTA";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";

export default function ServicesIndex() {
  const { lang } = useLang();
  const t = {
    fr: { tag: "Nos Services", title: "Ce que nous faisons, précisément.", lead: "Sept expertises complémentaires. Chaque service dispose de sa page détaillée avec livrables concrets et cas d'usage.", learn: "Voir le détail" },
    en: { tag: "Our Services", title: "What we do, precisely.", lead: "Seven complementary expertises. Each service has its own detailed page with concrete deliverables and use cases.", learn: "See details" },
  }[lang];

  return (
    <>
      <Seo
        title={lang === "fr" ? "Nos services de drone : inspection, cartographie, thermographie | Fixedrone" : "Our drone services: inspection, mapping, thermography | Fixedrone"}
        description={lang === "fr" ? "Découvrez les services de drone Fixedrone : inspection & thermographie, photovoltaïque, cartographie & topographie 3D, suivi de chantier, carrière, agriculture et énergie/industrie au Luxembourg." : "Discover Fixedrone drone services: inspection & thermography, photovoltaic, 3D mapping & surveying, construction monitoring, quarry, agriculture and energy/industry in Luxembourg."}
        keywords="services drone, inspection drone, cartographie drone, thermographie, photovoltaïque, topographie, suivi de chantier, agriculture de précision, Luxembourg"
        path="/services"
      />
      <section className="pt-40 pb-16 md:pb-24 bg-[#050505] relative">
        <div className="absolute inset-0 grid-lines opacity-20" />
        <div className="w-full max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-16 relative">
          <FadeUp><span className="font-mono-p text-xs uppercase tracking-[0.25em] text-primary-c">{t.tag}</span></FadeUp>
          <h1 className="font-display font-black text-5xl md:text-7xl tracking-tighter leading-[0.9] mt-6 max-w-4xl"><MaskLine load>{t.title}</MaskLine></h1>
          <FadeUp delay={0.1}><p className="text-white/60 mt-6 max-w-2xl text-base md:text-lg leading-relaxed">{t.lead}</p></FadeUp>
        </div>
      </section>

      <section className="pb-24 md:pb-32 bg-[#050505]">
        <div className="w-full max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-16 border-t border-white/10">
          {services.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Plane;
            return (
              <FadeUp key={s.slug}>
                <Link to={`/services/${s.slug}`} data-testid={`services-index-${s.slug}`} className="group grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10 items-center py-8 md:py-10 border-b border-white/10 hover:bg-white/[0.02] transition-colors duration-500">
                  <div className="lg:col-span-1 font-mono-p text-sm text-white/30">0{i + 1}</div>
                  <div className="lg:col-span-5 flex items-center gap-4">
                    <span className="shrink-0 w-11 h-11 rounded-full border border-white/20 flex items-center justify-center text-primary-c group-hover:bg-[var(--primary)] group-hover:text-black transition-colors duration-300"><Icon size={19} /></span>
                    <h2 className="font-display font-semibold text-2xl md:text-4xl tracking-tight group-hover:text-primary-c transition-colors duration-300">{s[lang].name}</h2>
                  </div>
                  <div className="lg:col-span-5 text-white/55 leading-relaxed">{s[lang].tagline}</div>
                  <div className="lg:col-span-1 flex lg:justify-end">
                    <span className="w-11 h-11 rounded-full border border-white/20 flex items-center justify-center group-hover:border-[var(--primary)] group-hover:text-primary-c transition-colors"><ArrowUpRight size={18} /></span>
                  </div>
                </Link>
              </FadeUp>
            );
          })}
        </div>
      </section>
      <CTA />
    </>
  );
}
